import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { H3, Text } from '../Typography';
import { Icon } from '../Icon';
export var StyledWrapper = styled.div(_templateObject(), function (props) {
  return "\n        display: flex;\n        width: ".concat(props.theme.components.displayInput.width, ";\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n        ").concat(props.singleSize ? "\n            margin-left: 20px;\n            width: 30px;\n        " : '', "\n    ");
});
export var StyledLabel = styled(H3)(_templateObject2(), function (props) {
  return "\n        margin-top: 0;\n        color: ".concat(props.theme.global.colors.doveGrayLight, ";\n        ").concat(props.disabled ? "color: ".concat(props.theme.global.colors.porcelainDarker, ";") : '', "\n    ");
});
export var StyledText = styled(Text)(_templateObject3(), function (props) {
  return props.error ? "color: ".concat(props.theme.global.colors.error, " !important;") : '';
});
export var StyledInput = styled.input(_templateObject4(), function (props) {
  return "\n        outline: 0 !important;\n        border: none !important;\n        box-shadow: unset !important;\n        padding: ".concat(props.theme.components.displayInput.padding, " !important;\n        font: ").concat(props.theme.global.typographyConfig.headings.h2.font, ";\n        color: inherit;\n        text-align: center;\n        width: 100%;\n\n        &::placeholder {\n            color: ").concat(props.theme.global.colors.porcelainDarker, ";\n        }\n\n        ").concat(props.icon ? "padding-right: 20px;" : '', "\n    ");
});
export var StyledInputContainer = styled.div(_templateObject5(), function (props) {
  return "\n        position: relative;\n        color: ".concat(props.disabled ? props.theme.global.colors.porcelainDarker : props.theme.global.colors.primary, ";\n        font-size: 14px;\n        border-bottom: 1px solid ").concat(props.theme.global.colors.porcelainDarker, " !important;\n        width: 100%;\n\n        ").concat(Icon.Styles.StyledIcon, " {\n            user-select: none;\n            cursor: pointer;\n            position: absolute;\n            display: block;\n        }\n\n        ").concat(Icon.Styles.StyledIcon, ":first-child {\n            left: 0;\n            top: 0;\n        }\n\n        ").concat(Icon.Styles.StyledIcon, ":last-child {\n            right: 0;\n            top: 0;\n        }\n    ");
});
export var StyledHelperContainer = styled.div(_templateObject6(), function (props) {
  return "\n        background-color: ".concat(props.theme.global.colors.primary, ";\n        border-radius: 50%;\n        display: inline-block;\n        margin-left: 5px;\n        position: relative;\n        height: 15px;\n        width: 15px;\n        vertical-align: text-top;\n        cursor: pointer;\n\n        & > svg {\n            color: ").concat(props.theme.global.colors.white, ";\n            font-size: 10px;\n            position: absolute;\n            top: 2px;\n            left: 5px;\n        }\n    ");
});